import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import _ from "lodash";
import { useState } from "react";
import { guessFeaturePrimaryKey } from "../explorer-page";

interface AttributesDynamicTableProps {
  attributes: {
    [key: string]: string;
  }[];
  onSelectFeature: (key: string) => void;
}

export const AttributesDynamicTable = (props: AttributesDynamicTableProps) => {
  const [selectedRow, setSelectedRow] = useState<{
    [key: string]: string;
  }>({});

  const handleRowClick = (rowData: { [key: string]: string }) => {
    setSelectedRow(rowData);
    props.onSelectFeature(
      rowData[guessFeaturePrimaryKey(Object.keys(rowData)) as string],
    );
  };

  return (
    <div
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      className="max-h-[200px] overflow-auto"
    >
      <Table>
        <TableHeader>
          <TableRow>
            {Object.keys(props.attributes[0]).map((key) => (
              <TableHead key={key} className="p-1 pr-2.5 font-bold">
                {key}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {props.attributes.map((object) => (
            <TableRow
              key={Object.values(object)[0]}
              className={`cursor-pointer hover:bg-accent ${
                _.isEqual(selectedRow, object) ? "bg-accent" : ""
              }`}
              onClick={() => handleRowClick(object)}
            >
              {Object.values(object).map((value, i) => (
                <TableCell key={i} className="p-1">
                  {value}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
